import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=cb3bda24&scoped=true&"
import script from "./TagEditor.vue?vue&type=script&lang=js&"
export * from "./TagEditor.vue?vue&type=script&lang=js&"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=cb3bda24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3bda24",
  null
  
)

export default component.exports